var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Trans } from '@lingui/react/macro';
import { Button } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { SearchableMenu, SearchableMenuMultiSelectList, SearchableMenuBody, } from 'shared/domains/common-ui/SearchableMenu';
import { useMetadataActions } from '../../hooks/useMetadataActions';
import { useDocumentMetadata } from '../DocumentMetadataProvider';
export function AddMetadataList() {
    const { data, toggleActiveEntry, activeEntries } = useDocumentMetadata();
    const actions = useMetadataActions();
    const searchableItems = data.properties.map(({ property, pair }) => ({
        id: property.id,
        label: property.label,
        name: property.name,
        pairId: pair.id,
    }));
    const selected = activeEntries
        .map((propertyName) => { var _a; return (_a = data.properties.find((property) => property.property.name === propertyName)) === null || _a === void 0 ? void 0 : _a.property.id; })
        .filter(Boolean);
    const handleOnSelect = (item) => __awaiter(this, void 0, void 0, function* () {
        const isSelected = selected.includes(item.id);
        if (isSelected && item.pairId) {
            yield actions.delete(item.pairId);
        }
        toggleActiveEntry(item.name);
    });
    return (<SearchableMenu items={searchableItems} keys={['label']} renderTarget={<Button size="small" $stretch appearance="secondary">
          <Trans id="metadata.list.action.show" comment="Metadata actions: Button to show list of available metadata tags to add">
            Add
          </Trans>
          <Falcon icon="plus"/>
        </Button>}>
      <SearchableMenuBody>
        <SearchableMenuMultiSelectList emptyComponent={false} selected={selected} renderItem={({ label }) => label} onSelect={handleOnSelect}/>
      </SearchableMenuBody>
    </SearchableMenu>);
}
